<template>
  <div class="carousel-box min-width">
    <el-carousel trigger="click" :autoplay="false" height="650px" ref="carousel" :initial-index="bannerIndex">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img
          class="slider-img"
          :src="item.imghref"
          alt=""
          @click="handleDetail(item)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  props: {
    height: {
      type: Number,
      default: 650
    },
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  watch: {
    bannerIndex: function(nv) {
      this.$refs.carousel.setActiveItem(nv)
    }
  },
  computed: {
    ...mapState({
      bannerIndex: (state) => state.bannerIndex
    })
  },
  mounted () {},
  methods: {
    handleDetail () {
      // this.$emit()
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-box {
  width: 100%;
  .slider-img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>
